import styled from "styled-components";

export const ProblemWrapper = styled.div`
width: 100%;
background: #C5FFF0 0% 0% no-repeat padding-box;
box-shadow: 32px 32px 48px #050E3514;
border-radius: 10px;
display: flex;
flex-direction: column;
padding-top: 50px;
padding-bottom: 50px;
`

export const Column = styled.div`
display: flex;
flex-direction: column;
justify-content: center;
width: 100%;
`

export const PorblemHeader = styled.div`
text-align: center;
font-Size: 48px;
font-weight: 900;
letter-spacing: -0.5px;
color: #091740;
margin-bottom: 20px;
`

export const ProblemDescription = styled.p`
text-align: center;
font-Size: 18px;
font-weight: 300;
letter-spacing: -0.19px;
color: #091740;
margin-bottom: 60px;
`

export const GetStartedButton = styled.button`
background: #1E40C8 0% 0% no-repeat padding-box;
box-shadow: 0px 16px 48px #050E353D;
border-radius: 28px;
padding: 10px 9px 10px 9px;
border: none;
text-align: center;
letter-spacing: -0.2px;
color: #FFFFFF;
font-size: 16px;
width: 100%;
cursor: pointer;
`